import { useState, useEffect } from 'react';
import { useQuery } from "@tanstack/react-query";
import { Modal, Row, Col, Card, Placeholder } from 'react-bootstrap';
import { UserApi } from '../../app/api/user.api';


export function EditUserModal({ show, onHide, user, refetch })
{  
    const users = UserApi();

    const [status, setStatus] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [checked, setChecked] = useState(false);
    const [role, setRole] = useState(0);

    useEffect ( () => setRole(user?.status), [user?.status] )

    const handleSubmit = async (e) => {
      e.preventDefault();
      setStatus(0);
      setIsLoading(true);
      try {
          const {data} = await users.updateStatus(user?.id, { newStatus : role });
          if( data.success ){
            setStatus(1);
            setMessage( data.message );
            refetch();
          }
          else{
            setStatus(-1);
            setMessage('Erreur ! veuillez réessayer');
          }
      } catch (err) { 
          setStatus(-1);
          setMessage(err?.response?.data.message);     
 
      } finally {
         setIsLoading(false);
      }
   }

    return(

      <Modal show={show} onHide={onHide} centered backdrop="static">
        <Modal.Header closeButton className="border-bottom">
          <Modal.Title className="text-green fs-5">
            <i className="bi bi-check-circle-fill text-green me-2"></i>
            Mise à jour utilisateur
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-4">
          <form className="d-flex flex-column justify-content-center p-4" onSubmit={ handleSubmit } >          
            {
                isLoading && (
                  <div className="d-flex justify-content-center mb-2"> 
                    <div className="spinner-border text-green" role="status" aria-label="Chargement"></div>
                  </div>
                )
            }
            {
                status === 1 && (
                  <div className="alert alert-success mb-2 small w-100"> { message } </div>  
                )
            }
            {
                status === -1 && (
                  <div className="alert alert-danger mb-2 small w-100"> { message } </div>  
                )
            }
            <select className="w-100 px-2 py-3 border mb-3 text-muted" value={ role } onChange={ e => setRole( e.target.value ) } name="status" >
              <option value=""> Choisir status  </option>
              <option value="user" > User </option>
              <option value="saler" > Saler </option>
              <option value="admin" > Admin </option>
              <option value="topadmin" > Top admin </option>
              <option value="block" > bloqué </option>
            </select>

            <input type="checkbox" name="name" checked={checked} onChange={(e) => setChecked(e.target.checked)} style={{ width: '20px', height: '20px' }} />
            <span className="small text-secondary mb-1"> Etes vous sure de vouloir modifier le Statut de cet utilisateur </span>
            <button type="submit" className="btn btn-green mt-3" disabled={!checked} > Enregistrer <i className="bi bi-chevron-right ms-1"></i> </button>

          </form>
        </Modal.Body>
        <Modal.Footer className="border-top d-flex gap-2 px-4">
          <button className="btn btn-sm btn-outline-danger" onClick={onHide}>  Annuler </button>
        </Modal.Footer>
      </Modal>
    )
}



export function StatContainer()
{
    const user = UserApi(); 

    const fetchData = async () => { 
      const {data} = await user.getCount();
      return data.data; 
    }
    const { isLoading, data=[], error } = useQuery({  queryKey: ["userStats"], queryFn: fetchData });


    if (isLoading){
      return (
        <Row className="g-4">
        {
          Array.from({ length: 6 }).map((_, index) => (
            <Col key={index} lg={4} md={4} sm={6} xs={12}>
              <Placeholder as="div" animation="glow" className="w-100 bg-secondary bg-opacity-25 rounded" style={{ height: '150px' }} />
            </Col>
          ))
        }
        </Row>
      )
    };
    if (error){
      return(
        <div className="text-center p-4 border alert alert-danger w-100">
          Une erreur est survenue. Vueiller vérifier votre connexion 
        </div>
      )
    }


    return(

      <Row className="g-4">
        { 
          data.map((item, index) => (
            <Col key={index} lg={4} md={4} sm={6} xs={12}>
              <Card className="stat-card h-100 rounded-0 border">
                <Card.Body className="text-center">
                  <div className="h3 text-secondary mb-2" > {item.count} </div>
                  <div className="text-secondary">{item.status}</div>
                </Card.Body>
              </Card>
            </Col>
        ))}
      </Row>

    )
}
